// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { FormControlLabel } from '@mui/material';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { Field } from 'mobx-react-form';
import { observer } from 'mobx-react';
import { getScrollAttr } from '@shared/utils/form';

export interface CheckboxProps extends Omit<MuiCheckboxProps, 'onChange'> {
  field?: Field;
  label?: React.ReactNode;
  onChange?: (checked: boolean) => any;
}

@observer
class Checkbox extends React.Component<CheckboxProps> {
  private handleChange = (e, checked: boolean) => {
    const { field, onChange } = this.props;

    if (field) {
      field.set('value', checked);
    }

    if (onChange) {
      onChange(checked);
    }
  }

  render() {
    const { field, checked, label, onChange, ...otherProps } = this.props;

    return (
      <FormControlLabel
        control={(
          <MuiCheckbox
            disableRipple
            {...getScrollAttr(field?.name || otherProps.name)}
            checked={field ? field.value : checked}
            onChange={this.handleChange}
            {...otherProps}
          />
        )}
        label={label}
      />
    );
  }
}

export default Checkbox;